export const chains = [
  { symbol: 'BTC', name: 'BITCOIN', id: -1, browser: 'https://www.blockchain.com/btc/tx/' },
  { symbol: 'ETH', name: 'ETHEREUM', id: 1, browser: 'https://etherscan.io/tx/' },
  { symbol: 'SOL', name: 'SOLANA', id: 501424, browser: 'https://solscan.io/tx/' },
  { symbol: 'BSC', name: 'BSC', id: 56, browser: 'https://bscscan.com/tx/' },
  { symbol: 'BASE', name: 'BASE', id: 8453, browser: 'https://basescan.org/tx/' },
  { symbol: 'TRON', name: 'TRON', id: 728126428, browser: 'https://tronscan.org/#/transaction/' },
  { symbol: 'ARB', name: 'ARBITRUM', id: 42161, browser: 'https://arbiscan.io/tx/' },
  { symbol: 'POL', name: 'POLYGON', id: 137, browser: 'https://polygonscan.com/tx/' },
  { symbol: 'HYPERLIQUID', name: 'HYPERLIQUID', id: 0, browser: 'https://app.hyperliquid.xyz/explorer/tx/' },
  { symbol: 'MON', name: 'MONAD', id: 143, browser: 'https://monadexplorer.com/tx/' },
  { symbol: 'HYPERLIQUID', name: 'HYPERLIQUID', id: 999, browser: 'https://app.hyperliquid.xyz/explorer/tx/' },
  { symbol: 'ANIME', name: 'ANIMECHAIN', id: 69000, browser: 'https://explorer.animechain.ai/tx/' },
];
